<template>
  <div
    class="jump-mini-app-container"
    v-html="html"
  />
</template>

<script lang="ts">
/* eslint-disable no-useless-escape */
import { defineComponent } from 'vue';
import { initWXConf } from '@/utils/wx';
import { randomString } from '@/utils/common';

const enum EEmitEvent {
  launch = 'launch',
}

export default defineComponent({
  props: {
    path: {
      type: String,
      default: '',
    },
  },
  emits: [EEmitEvent.launch],
  data() {
    return {
      openLaunchId: '',
    };
  },
  computed: {
    html() {
      const { openLaunchId } = this;
      return `
      <wx-open-launch-weapp
        username="gh_707200af2d53"
        path="${this.path}"
        id="${openLaunchId}"
        class="launch-btn"
      >
        <script type="text/wxtag-template">
          <style>.wx-btn { width: 100%; height: 1000px;opacity:0 }</style>
          <button class="wx-btn"></button>
        <\/script>
      </wx-open-launch-weapp>
      `;
    },
  },
  async mounted() {
    await this.init();
    this.openLaunchId = randomString(16);
    this.$nextTick(() => this.onLaunch());
  },
  methods: {
    async init() {
      await initWXConf({ useWeishi: true, isOpenTagList: true });
    },
    onLaunch() {
      const btn = document.getElementById(this.openLaunchId) as HTMLElement;
      if (!btn) return;
      btn.addEventListener('launch',  () => {
        console.log('onLaunch');
        this.$emit(EEmitEvent.launch);
      });
    },
  },
});
</script>

<style lang="scss">
.jump-mini-app-container {
  .launch-btn {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    overflow: hidden;
  }
}
</style>
